/**
 * Public contact details for the Contact us screen.
 * Team list supplied by the product owner (2026-09); support address and registered office
 * are the ones published on the tick2trade.com legal pages.
 */
export type SupportContactPerson = {
    name: string
    role: string
    /** Ten-digit Indian mobile number, digits only. */
    phone: string
    email: string
}

export const SUPPORT_TEAM: SupportContactPerson[] = [
    { name: 'Vibhu Garg', role: 'Designated Partner', phone: '9711977441', email: 'vibhu@besseggen.in' },
    { name: 'Ankit Pruthi', role: 'Designated Partner', phone: '8826680745', email: 'ankit@besseggen.in' },
    { name: 'Karun Singla', role: 'Designated Partner', phone: '9910334586', email: 'karun@besseggen.in' },
    { name: 'Kumar Kunal Raj', role: 'Compliance Officer', phone: '9555508501', email: 'compliance@besseggen.in' }
]

export const SUPPORT_EMAIL = 'support@tick2trade.com'
export const WEBSITE_URL = 'https://tick2trade.com'
export const COMPANY_NAME = 'Besseggen InfoTech LLP'
export const REGISTERED_OFFICE = [
    'Office No. 1115, 11th Floor, Astralis Tower, Supernova',
    'Plot No. 3, Sector 94, Noida, Uttar Pradesh 201301'
]

/** "9711977441" → "+91 97119 77441" */
export const formatIndianMobile = (digits: string) => `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`

export const telHref = (digits: string) => `tel:+91${digits}`

export const initialsOf = (name: string) =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase() ?? '')
        .join('')
